import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useLocalStorage, useOnBoarding } from "_hooks";
import { Base } from "components/template";
import { DialCode, InputControl } from "components/organism";
import { ProgressBar } from "components/molecules";
import { userDataSchema } from "_config/formSchemas";
import { Button } from "components/atoms";
import { userData } from "_config/store/onBoarding/onBoarding.thunk";

const prefix = "v-user-data";

const UserData = () => {
  const dispatch = useDispatch();
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(userDataSchema)
  });

  const [onBoarding, setOnBoarding] = useLocalStorage("onBoarding");
  const [country, setCountry] = useState();
  const navigate = useNavigate();
  const { state } = useLocation();
  const initialized = useRef(null);

  const { fetchCountries, fetchProductTypes } = useOnBoarding();
  const { data: response, isLoading } = useSelector((s) => s.onBoarding.userData);

  const onSubmit = (data) => {
    let { phone } = data;
    dispatch(userData(onBoarding?._id, {
      ...data,
      phonenumber: `${country?.dialCode}${phone}`
    }));
  };

  useEffect(() => {
    if (!initialized?.current) {
      initialized.current = true;
      fetchCountries();
      fetchProductTypes();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (response !== null) {
      setOnBoarding(response);
      setTimeout(() => navigate("/account/companyData", { state }), 100);
    }
  }, [response]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Base
      align="normal"
      header={<ProgressBar max={6} progress={2} />}
      headerClass={"mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px] mt-10 mb-0"}
    >
      <div className={`${prefix} flex flex-wrap flex-col p-3 mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px]`}>
        <div className="flex flex-wrap flex-col gap-3 ">
          
          <p className="text-center text-3xl font-bold mx-auto mt-5">Datos de usuario</p>
          <p className="text-center text-xl mx-auto mb-2">Para conocerte mejor</p>
        
          <form 
            className="flex flex-wrap flex-col gap-7"
            onSubmit={handleSubmit(onSubmit)}
          > 
            <InputControl
              errors={errors?.name}
              label={"Nombre"}
              name="firstName"
              orientation="vertical"
              inputProps={{
                autoComplete: "off",
                ...register("firstName"),
                placeholder: "Ej. Marisol"
              }}
            />

            <InputControl
              errors={errors?.lastName}
              label={"Apellido"}
              name="lastName"
              orientation="vertical"
              inputProps={{
                autoComplete: "off",
                ...register("lastName"),
                placeholder: "Ej. Rodríguez"
              }}
            />

            <DialCode
              errors={errors?.phone}
              name="phone"
              inputProps={{
                ...register("phone"),
              }}
              onChangeCountry={setCountry}
            />

            <Button
              className="bg-primary text-white rounded-lg mt-5"
              disabled={isLoading}
              fullwidth
              pulse
              spin={isLoading}
              type="submit"
            >Continuar</Button>
          </form>
        </div>
        
      </div>
    </Base>
  );
};

export default UserData;
